import { render, staticRenderFns } from "./apiAdmin.vue?vue&type=template&id=6465c942"
import script from "./apiAdmin.vue?vue&type=script&lang=js"
export * from "./apiAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports